import { coreApi as http, setPackageVersionGetter } from '@repo/core-api'
import packageJson from '../../../package.json'

// Set the package version getter to use the local package.json
setPackageVersionGetter(() => packageJson.version)

export default http
